import {createContext, useCallback, useContext, useEffect, useState} from 'react';
import {
    CONSENT_ACCEPTED,
    CONSENT_REJECTED,
    COOKIE_CONSENT_EVENT,
    getStoredConsent,
    setStoredConsent
} from '../utils/cookieConsent';
import {loadPixel, trackPageView} from '../utils/fbPixel';

const CookieConsentContext = createContext({
    consent          : null,
    isBannerVisible  : false,
    acceptConsent    : () => {
    },
    rejectConsent    : () => {
    },
    openConsentSettings : () => {
    }
});

export const CookieConsentProvider = (props) => {
    const [consent, setConsent] = useState(getStoredConsent);

    useEffect(() => {
        if (consent === CONSENT_ACCEPTED) {
            loadPixel();
            trackPageView();
        }
    }, [consent]);

    useEffect(() => {
        const handler = (event) => setConsent(event.detail);
        window.addEventListener(COOKIE_CONSENT_EVENT, handler);
        return () => window.removeEventListener(COOKIE_CONSENT_EVENT, handler);
    }, []);

    const acceptConsent = useCallback(() => setStoredConsent(CONSENT_ACCEPTED), []);
    const rejectConsent = useCallback(() => setStoredConsent(CONSENT_REJECTED), []);
    const openConsentSettings = useCallback(() => setStoredConsent(null), []);

    return (
        <CookieConsentContext.Provider value={{
            consent,
            isBannerVisible : consent === null,
            acceptConsent,
            rejectConsent,
            openConsentSettings
        }}>
            {props.children}
        </CookieConsentContext.Provider>
    );
};

export const useCookieConsent = () => useContext(CookieConsentContext);
